import axios from "axios";

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

const reportService = {
    getReportInfo: async () => {
        try {
            const response = await axios.get(
                `${API_ENDPOINT}powerbi/getReport`
            );
            return response.data;
        } catch (error) {
            console.error("Error fetching form data:", error);
            throw error; // Re-throw to handle in components
        }
    }
};

export default reportService;